import {
  readMedicationDose,
  formatMedicationDose,
} from "../../shared/medicationDose";
export const getMedicationPrimaryDoseLabel = (entry = {}) => {
  if (!entry) return "";
  const schedule =
    entry.schedules?.[0] || entry.canonicalMedicationRecord?.medication || {};
  return formatMedicationDose({
    dose: schedule.dose || entry.dose,
    unit: schedule.unit || entry.unit,
    doseText: schedule.doseText || entry.doseText,
  });
};
export const getPlanHistoryDoseLabel = (dose = "", unit = "") =>
  formatMedicationDose({ dose, unit });
export const normalizeMedicationScheduleQuantity = (
  entry = {},
  fallbackId = "",
) => {
  const quantity = readMedicationDose(entry);
  return {
    id:
      entry.id ||
      fallbackId ||
      `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    dose: quantity.amount,
    unit: quantity.unit,
    doseText: quantity.doseText,
    time: String(entry.time || "").trim(),
    doseNeedsClarification: quantity.needsClarification,
  };
};
export const assertMedicationDoseReady = (medication) => {
  const canonical = medication.canonicalMedicationRecord?.medication || {};
  const values = [medication, canonical, ...(medication.schedules || [])];
  for (const value of values) {
    const quantity = readMedicationDose({
      dose: value.dose,
      unit: value.unit || medication.unit || canonical.unit,
      doseText: value.doseText,
    });
    if ((value.dose || value.doseText) && quantity.needsClarification)
      throw new Error(quantity.reason);
  }
};
export const buildMedicationDetailSummary = (normalized, categoryLabel) => {
  if (!normalized.name) return "";
  const schedules = normalized.schedules || [];
  const labels = schedules
    .map((schedule) =>
      [formatMedicationDose(schedule), schedule.time]
        .filter(Boolean)
        .join(" • "),
    )
    .filter(Boolean);
  const parts = [normalized.name];
  if (labels.length) {
    parts.push(labels.slice(0, 2).join(" • "));
    if (labels.length > 2) parts.push(`+${labels.length - 2} more`);
  } else {
    const dose = formatMedicationDose(normalized);
    if (dose) parts.push(dose);
    if (normalized.time) parts.push(normalized.time);
  }
  if (schedules.length > 1 && !labels.length)
    parts.push(`${schedules.length} doses`);
  return `${categoryLabel}: ${parts.join(" • ")}`;
};
